var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import apiMiddleWare from "./middleware/api";
import transformMiddleWare from "./middleware/transform";
import chequeBlockMiddleware from "./middleware/chequeBlockMiddleware";
// import DevTools from './containers/DevTools';
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";
import createSagaMiddleware, { END } from "redux-saga";
import loadInitialState from "./loadInitialState";
import { saveState } from "./storage";
export var history = createBrowserHistory();
var sagaMiddleware = createSagaMiddleware();
var isDevelop = process.env.NODE_ENV === "development";
var initialState = loadInitialState();
var enhancers = [];
var middleware = [
    thunk,
    routerMiddleware(history),
    sagaMiddleware,
    apiMiddleWare,
    transformMiddleWare,
    chequeBlockMiddleware
];
var composedEnhancers = isDevelop
    ? composeWithDevTools.apply(void 0, __spreadArray([applyMiddleware.apply(void 0, middleware)], enhancers, false)) : compose.apply(void 0, __spreadArray([applyMiddleware.apply(void 0, middleware)], enhancers, false));
var store = createStore(rootReducer, initialState, composedEnhancers);
store.subscribe(function () {
    saveState({
        betSlips: store.getState().coupon.get("betSlips")
    });
});
store.runSaga = sagaMiddleware.run;
store.close = function () { return store.dispatch(END); };
export default store;



// WEBPACK FOOTER //
// ./src/store.js